import { FieryRecordSave, FieryRecordRemove } from "fiery-vuex"
import store from '../index'

class User {
	updatedAt: Date | null = null
	createdAt: Date | null = null
	updatedBy: string | null = null
	role: string = "agent"
	firm_id: string | null = null
	first_name: string | null = null
	last_name: string | null = null
	email: string | null = null
	phone: string | null = null
	address: string | null = null
	city: string | null = null
	state: string | null = null
	zip: string | null = null

	create() {
		console.log("CREATE USER")
		this.createdAt = new Date()
		this.updatedAt = new Date()
		return this.save()
	}

	update() {
		if (!this.createdAt) {
			return this.create()
		}

		this.updatedAt = new Date()
		return this.save()
	}

	save: FieryRecordSave
	remove: FieryRecordRemove
}

const UserOptions = {
	shared: true,
	type: User,
	include: [
		"updatedAt",
		"createdAt",
		"updatedBy",
		"role",
		"first_name",
		"last_name",
		"email",
		"phone",
		"address",
		"city",
		"state",
		"zip",
		"firm_id"
	],
	exclude: ["exists", "id"], // Only required if not using include but add for clarification
	timestamps: ["updatedAt", "createdAt"],
	record: true,
	recordOptions: {
		save: "save",
		remove: "remove"
	},
	key: "id",
	propExists: "exists"
}

export default User
export { User, UserOptions }
